/* eslint-disable max-len */
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { logError } from '@log';
import { RespCode } from '@constants';
import { useNavigate } from 'react-router-dom';
// import { MOCK_FEEDBACK_RESP } from '../../api/mock';
import { request } from '@api';
import { useBehaviorData } from '@/hooks';

const feedbackDataMap = new Map();

const getFeedbackData = async ({ policyId, claimId }) => {
  try {
    const resp = await request('get-claim-detail', {
      body: {
        claimId,
        policyId,
      },
    });
    const { code } = resp || {};
    if (code !== RespCode.Success) {
      logError(new Error(`failed, resp=${JSON.stringify(resp)}`));
    }
    return resp;
  } catch (e) {
    logError(e);
    return null;
  }
};

const useFeedback = () => {
  const { policyId } = useSelector((state) => state.claim);
  const {
    reasonList,
  } = useSelector((state) => state.policy);
  const [isLoading, setIsLoading] = useState(false);
  const [list, setList] = useState([]);
  // const dispatch = useDispatch();
  const [detailInfo, setDetailInfo] = useState({ history: [] });
  const [tabIndex, setTabIndex] = useState(0);
  const navigate = useNavigate();
  const setReportData = useBehaviorData();
  const [open, setOpen] = useState(false);

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };
  const getFeedbackList = async (claimId) => {
    setIsLoading(true);
    const resp = await getFeedbackData({ policyId, claimId });
    if (resp.code !== 0) {
      navigate('/17track/error', { state: { code: resp.code, backStep: -2 } });
      setIsLoading(false);
      return;
    }
    const { data: { relatedClaims, ...currentReturnDetail } = {} } = resp;
    feedbackDataMap.set(claimId, currentReturnDetail);
    const currentTab = relatedClaims
      ?.findIndex((v) => v.claimId === currentReturnDetail.claimId);
    setList(relatedClaims);
    setDetailInfo(currentReturnDetail);
    setTabIndex(currentTab);
    setIsLoading(false);
  };

  const onChange = async (e, tab) => {
    setOpen(false);
    const info = feedbackDataMap.get(list[tab]?.claimId);
    if (info) {
      setTabIndex(tab);
      setDetailInfo(info);
    } else {
      getFeedbackList(list[tab].claimId, tab);
    }
  };

  const reportIssureClick = () => {
    setReportData({ reportIssueTime: Date.now() });
    navigate('/17track/options');
  };

  return {
    tabIndex,
    detailInfo,
    list,
    isLoading,
    reasonList,
    open,
    policyId,
    toggleDrawer,
    onChange,
    getFeedbackList,
    reportIssureClick,
  };
};
export default useFeedback;
